
/**
 * Custom component for Pancho & Willie's Dessert menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-13 (1.0.0) (jhoward)
 *      - <panchoWilliesDessertSection> adds a simple center aligned menu type.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import PanchoWilliesDefaultSection from "./PanchoWillies_defaultSection.vue";

export default defineComponent({
  name: 'PanchoWillies_dessertSection',
  components: {PanchoWilliesDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
